<h2>
  {{ 'Gestione oggetti artistici' | translate }}
</h2>

<ui-table
  [filters]="filters$ | async"
  [rowSelection]="'checkbox'"
  [fields]="fields"
  [pager]="pager$"
  [reload]="reload$"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="(page$ | async)?.limit"
  [selected]="selectedItems?.length ? selectedItems : []"
  [contextMenuActions]="contextMenus"
  (itemsPageChange)="applyChangePageHandler($event)"
  (select)="selectHandler($event)"
  (rowAction)="manageRowActions($event)">
  <div tableActions>
    <app-entity-actions
      className="BeneOA"
      [selectedItemsCount]="selectedItems?.length || 0"
      [config]="{ showExport: !!isExportEnable }"
      (add)="addHandler()"
      (delete)="deleteSelectedHandler()"
      (export)="exportHandler()"
      (collectionAdd)="addToCollectionHandler()">
    </app-entity-actions>
  </div>
  <div tableFilters>
    <ui-filters
      [dialogFilters]="MobileFiltersComponent"
      (action)="applyFilterWithDelayHandler($event)">
      <app-card-oa-filters
        [filters]="filtersObj$ | async"
        #desktopFilter>
      </app-card-oa-filters>
    </ui-filters>
  </div>
</ui-table>
